const menu = [
    {
        category: 'breakfasts',
        products:
        [
            {
                id: 1,
                title: 'buttermilk pancakes',
                category: 'breakfast',
                price: 15.99,
                img: './images/product.png',
                desc: `I'm baby woke mlkshk wolf bitters live-edge blue bottle, hammock freegan copper mug whatever cold-pressed `,
              },
              {
                id: 2,
                title: 'diner double',
                category: 'breakfast',
                price: 13.99,
                img: './images/product.png',
                desc: `vaporware iPhone mumblecore selvage raw denim slow-carb leggings gochujang helvetica man braid jianbing. Marfa thundercats `,
              },
              {
                id: 3,
                title: 'godzilla milkshake',
                category: 'shakes',
                price: 6.99,
                img: './images/product.png',
                desc: `ombucha chillwave fanny pack 3 wolf moon street art photo booth before they sold out organic viral.`,
              }

        ]
    },
    {
        category: 'lunch',
        products:
        [
            {
                id: 4,
                title: 'country delight',
                category: 'lunch',
                price: 20.99,
                img: './images/product.png',
                desc: `Shabby chic keffiyeh neutra snackwave pork belly shoreditch. Prism austin mlkshk truffaut, `,
              },
              {
                id: 5,
                title: 'egg attack',
                category: 'lunch',
                price: 22.99,
                img: './images/product.png',
                desc: `franzen vegan pabst bicycle rights kickstarter pinterest meditation farm-to-table 90's pop-up `,
              },
              {
                id: 6,
                title: 'oreo dream',
                category: 'lunch',
                price: 18.99,
                img: './images/product.png',
                desc: `Portland chicharrones ethical edison bulb, palo santo craft beer chia heirloom iPhone everyday`,
              }
        ]
    },
    {
        category: 'shakes',
        products:
        [
            {
                id: 7,
                title: 'bacon overflow',
                category: 'shakes',
                price: 8.99,
                img: './images/product.png',
                desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
              },
              {
                id: 8,
                title: 'american classic',
                category: 'shakes',
                price: 12.99,
                img: './images/product.png',
                desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
              },
              {
                id: 9,
                title: 'quarantine buddy',
                category: 'shakes',
                price: 16.99,
                img: './images/product.png',
                desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
              }
        ]
    } ,
    {
        category: 'shakes2',
        products:
        [
            {
                id: 7,
                title: 'bacon overflow',
                category: 'shakes',
                price: 8.99,
                img: './images/product.png',
                desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
              },
              {
                id: 8,
                title: 'american classic',
                category: 'shakes',
                price: 12.99,
                img: './images/product.png',
                desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
              },
              {
                id: 9,
                title: 'quarantine buddy',
                category: 'shakes',
                price: 16.99,
                img: './images/product.png',
                desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
              }
        ]
    }  ,
    {
        category: 'shakes3',
        products:
        [
            {
                id: 7,
                title: 'bacon overflow',
                category: 'shakes',
                price: 8.99,
                img: './images/product.png',
                desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
              },
              {
                id: 8,
                title: 'american classic',
                category: 'shakes',
                price: 12.99,
                img: './images/product.png',
                desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
              },
              {
                id: 9,
                title: 'quarantine buddy',
                category: 'shakes',
                price: 16.99,
                img: './images/product.png',
                desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
              }
        ]
    },
    
    {
        category: 'shakes4',
        products:
        [
            {
                id: 7,
                title: 'bacon overflow',
                category: 'shakes',
                price: 8.99,
                img: './images/product.png',
                desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
              },
              {
                id: 8,
                title: 'american classic',
                category: 'shakes',
                price: 12.99,
                img: './images/product.png',
                desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
              },
              {
                id: 9,
                title: 'quarantine buddy',
                category: 'shakes',
                price: 16.99,
                img: './images/product.png',
                desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
              }
        ]
    } ,

    {
        category: 'shakes5',
        products:
        [
            {
                id: 7,
                title: 'bacon overflow',
                category: 'shakes',
                price: 8.99,
                img: './images/product.png',
                desc: `carry jianbing normcore freegan. Viral single-origin coffee live-edge, pork belly cloud bread iceland put a bird `,
              },
              {
                id: 8,
                title: 'american classic',
                category: 'shakes',
                price: 12.99,
                img: './images/product.png',
                desc: `on it tumblr kickstarter thundercats migas everyday carry squid palo santo leggings. Food truck truffaut  `,
              },
              {
                id: 9,
                title: 'quarantine buddy',
                category: 'shakes',
                price: 16.99,
                img: './images/product.png',
                desc: `skateboard fam synth authentic semiotics. Live-edge lyft af, edison bulb yuccie crucifix microdosing.`,
              }
        ]
    } 
    
  ];
  export default menu;
  